<template>
  <div>
    <div class="toolbar">
      <el-input
        v-model="keyword"
        clearable
        placeholder="单号 / 材料"
        style="width:200px"
        @keyup.enter.native="load"
      />
      <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
      <el-button icon="el-icon-download" :loading="exporting" :disabled="!list.length" @click="onExport">导出</el-button>
    </div>

    <el-table :data="pageList" border v-loading="loading" show-summary :summary-method="summaryMethod">
      <el-table-column prop="returnNo" label="退货单号" width="160" show-overflow-tooltip />
      <el-table-column prop="projectName" label="项目" min-width="140" show-overflow-tooltip />
      <el-table-column prop="materialName" label="材料" min-width="140" show-overflow-tooltip />
      <el-table-column prop="specs" label="规格" width="110" show-overflow-tooltip>
        <template slot-scope="{ row }">{{ row.specs || '-' }}</template>
      </el-table-column>
      <el-table-column prop="unit" label="单位" width="70" align="center">
        <template slot-scope="{ row }">{{ row.unit || '-' }}</template>
      </el-table-column>
      <el-table-column prop="qty" label="退货数量" width="100" align="right">
        <template slot-scope="{ row }">{{ fmtQty(row.qty) }}</template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip>
        <template slot-scope="{ row }">{{ row.remark || '-' }}</template>
      </el-table-column>
      <el-table-column prop="createdByName" label="退货人" width="100" show-overflow-tooltip>
        <template slot-scope="{ row }">{{ row.createdByName || '-' }}</template>
      </el-table-column>
      <el-table-column label="退货时间" width="120">
        <template slot-scope="{ row }">{{ fmtDate(row.createdAt) }}</template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="listTotal"
      :page="page"
      :page-size="pageSize"
      @current-change="onPageChange"
      @size-change="onPageSizeChange"
    />
  </div>
</template>

<script>
import { listMaterialReturnLineRows, exportMaterialReturnLineRows } from '../../api/supply'
import ListPagination from '../../components/ListPagination.vue'
import listPaging from '../../mixins/listPaging'

export default {
  name: 'SupplierReturnLines',
  components: { ListPagination },
  mixins: [listPaging],
  data() {
    return {
      keyword: '',
      list: [],
      loading: false,
      exporting: false
    }
  },
  created() {
    this.load()
  },
  methods: {
    num(v) {
      const n = Number(v)
      return Number.isFinite(n) ? n : 0
    },
    fmtQty(v) {
      if (v == null || v === '') return '0'
      const n = this.num(v)
      if (Number.isInteger(n)) return String(n)
      return String(Math.round(n * 10000) / 10000)
    },
    fmtDate(v) {
      if (!v) return '-'
      return String(v).slice(0, 10)
    },
    summaryMethod({ columns }) {
      const sums = []
      const rows = this.list || []
      columns.forEach((col, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (col.property === 'qty') {
          let total = 0
          rows.forEach(r => { total += this.num(r.qty) })
          sums[index] = this.fmtQty(total)
        } else {
          sums[index] = ''
        }
      })
      return sums
    },
    queryParams() {
      return { keyword: this.keyword || undefined }
    },
    async load() {
      this.loading = true
      try {
        const res = await listMaterialReturnLineRows(this.queryParams())
        this.list = res.data || []
        this.page = 1
      } finally {
        this.loading = false
      }
    },
    async onExport() {
      if (!this.list.length) {
        return this.$message.warning('暂无数据可导出')
      }
      this.exporting = true
      try {
        const res = await exportMaterialReturnLineRows(this.queryParams())
        const blob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = '退货明细.xlsx'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(url)
      } catch (e) {
        this.$message.error('导出失败')
      } finally {
        this.exporting = false
      }
    }
  }
}
</script>

<style scoped>
.toolbar { display: flex; gap: 8px; margin-bottom: 12px; flex-wrap: wrap; }
</style>
